import dayjs from "dayjs";

export function parseInputs(data, investorRate) {
  const loanAmount = Number(
    typeof data?.ammount === "string"
      ? data?.ammount.replace(/\./g, "")
      : data?.ammount ?? 0
  );

  const annualRate = investorRate
    ? investorRate / 100
    : Number(data?.tasa ?? 0) / 100;

  return {
    loanAmount,
    annualRate,
    monthlyRate: annualRate / 12,
    loanTerm: Number(data?.month ?? 0),
    startDate: dayjs(data?.start_date, "YYYY-MM-DD"),
    payments: Array.isArray(data?.payments) ? data.payments : [],
    paymentsInvestor: Array.isArray(data?.paymentsInvestor)
      ? data.paymentsInvestor
      : [],
    abonos: Array.isArray(data?.abono) ? data.abono : [],
  };
}
